module.exports = __webpack_public_path__ + "static/media/scroll02_2.541fa964.png";